var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3566 5.3503C13.2689 5.07913 13.0284 4.88654 12.7438 4.86089L8.87869 4.50994L7.35031 0.932611C7.23761 0.670439 6.98096 0.500732 6.6958 0.500732C6.41064 0.500732 6.15398 0.670439 6.04129 0.933224L4.51291 4.50994L0.647152 4.86089C0.363115 4.88715 0.123217 5.07913 0.0350431 5.3503C-0.0531308 5.62146 0.0282998 5.91888 0.243166 6.10636L3.16476 8.66862L2.30325 12.4636C2.24021 12.7426 2.34851 13.031 2.58003 13.1984C2.70447 13.2883 2.85007 13.3341 2.99689 13.3341C3.12348 13.3341 3.24905 13.2999 3.36174 13.2325L6.6958 11.2399L10.0286 13.2325C10.2725 13.3792 10.5799 13.3658 10.811 13.1984C11.0426 13.0305 11.1508 12.742 11.0877 12.4636L10.2262 8.66862L13.1478 6.10687C13.3627 5.91888 13.4447 5.62197 13.3566 5.3503Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBlack);
export default __webpack_public_path__ + "static/media/star-black.895fd5d34c7a510e14a3f8fd0c56ad6c.svg";
export { ForwardRef as ReactComponent };